<template>
  <Modal
    class="cc-modal"
    width="600"
    footer-hide
    v-model="visibility"
    title="企业认证"
  >
    <div class="content" style="position: relative">
      <loading :loading="loading" style="z-index: 11"></loading>
      <div class="section">
        <div class="bj-rows">
          <div class="name">企业名称：</div>
          <Input
            class="bj-input-h45 bj-hover-input-F85A36"
            v-model="form.enterpriseName"
            placeholder="请输入企业名称"
            style="width: 250px"
            clearable
          />
        </div>
        <div class="bj-rows">
          <div class="name">证件类型：</div>
          <Select
            class="bj-select-h45 bj-hover-select-F85A36"
            v-model="form.certificateType"
            style="width: 250px"
          >
            <Option
              v-for="item in typeList"
              :key="item.value"
              :value="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </div>
        <div class="bj-rows">
          <div class="name">证件号码：</div>
          <Input
            class="bj-input-h45 bj-hover-input-F85A36"
            v-model="form.certificateNumber"
            placeholder="请输入证件号码"
            style="width: 250px"
            clearable
          />
        </div>
        <div class="c-bj-rows">
          <div class="name">证件正面照：</div>
          <Upload
            v-if="!form.imgUrl"
            style="width: 250px"
            type="drag"
            :before-upload="handleBeforeUpload"
            :show-upload-list="false"
            action="/"
          >
            <div class="upload-section">
              <Icon type="md-cloud-upload" size="64" />
            </div>
          </Upload>
          <div
            class="icon2"
            :style="{ backgroundImage: 'url(' + form.imgUrl + ')' }"
            v-else
          >
            <div class="close" @click="delImage">
              <Icon size="28" type="ios-close-circle-outline" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="foot">
      <Button :loading="loading" @click="onConfirm" class="modal-confirm" style="margin-right: 20px" >确定</Button>
      <Button @click="onCancel" class="modal-cancel">取消</Button>
    </div>
  </Modal>
</template>
<script>
import { enterpriseIdentitySave, enterpriseIdentityUpload } from "api/user.js";
import { mapMutations } from "vuex";
import loading from "components/loading.vue";
export default {
  name: "updateCertifiedModal",
  components: {
    loading,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      typeList: [
        {
          value: 1,
          label: "企业组织机构代码证",
        },
        {
          value: 2,
          label: "营业执照",
        },
        {
          value: 4,
          label: "统一社会信用代码证",
        },
        {
          value: 3,
          label: "北京市外国驻华使馆人员子女学校办学许可证",
        },
        {
          value: 5,
          label: "事业单位法人证书",
        },
        {
          value: 6,
          label: "社会团体法人登记证书",
        },
        {
          value: 7,
          label: "民办非企业单位登记证书",
        },
        {
          value: 8,
          label: "律师事务所执业许可证",
        },
        {
          value: 9,
          label: "司法鉴定许可证",
        },
        {
          value: 10,
          label: "宗教活动场所登记证",
        },
        {
          value: 11,
          label: "基金会法人登记证书",
        },
        {
          value: 12,
          label: "部队代号",
        },
        {
          value: 13,
          label: "军队单位对外有偿服务许可证",
        },
        {
          value: 14,
          label: "外国企业常驻代表机构登记证",
        },
        {
          value: 15,
          label: "外国在华文化中心登记证",
        },
        {
          value: 16,
          label: "外国政府旅游部门常驻代表机构批准登记证",
        },
        {
          value: 17,
          label: "境外机构证件",
        },
        {
          value: 18,
          label: "社会服务机构登记证书",
        },
        {
          value: 19,
          label: "民办学校办学许可证",
        },
        {
          value: 20,
          label: "医疗机构执业许可证",
        },
        {
          value: 31,
          label: "仲裁委员会登记证",
        },
        {
          value: 32,
          label: "农村集体经济组织登记证",
        },
        {
          value: 33,
          label: "中华人民共和国社会信用代码证书",
        },
        {
          value: 34,
          label: "港澳台地区旅游部门常驻代表机构批准登记证",
        },
        {
          value: 35,
          label: "外国驻华新闻机构证",
        },
        {
          value: 36,
          label: "境外非政府组织代表机构登记证书",
        },
        {
          value: 37,
          label: "港澳新闻机构常驻内地记者站登记证",
        },
        {
          value: 38,
          label: "其他境外机构登记证",
        }
      ],
      form: {
        enterpriseName: "",
        certificateType: 0, // 0：身份证 1：护照
        certificateNumber: "",
        file: "",
        imgPathName: "",
        imgUrl: "",
        legalPerson: "",
      },
      loading: false,
      uploading: false,
    };
  },
  computed: {
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  methods: {
    ...mapMutations(["MUT_USER_INFO_COMPANY"]),
    onCancel() {
      this.form = this.$options.data().form;
      this.visibility = false;
    },
    async onConfirm() {
      if (!this.form.enterpriseName) {
        this.$Message.warning("请输入企业名称！");
        return;
      }
      if (!this.form.certificateNumber) {
        this.$Message.warning("请输入正确的证件号码！");
        return;
      }
      if (!this.form.imgPathName) {
        this.$Message.warning("请上传证件正面图片！");
        return;
      }
      this.loading = true;
      const data = {
        cpn: this.form.enterpriseName,
        type: this.form.certificateType, // 0：身份证 1：护照
        ca: this.form.certificateNumber,
        imgN: this.form.imgPathName,
        imgU: this.form.imgUrl,
      };
      try {
        const res = await enterpriseIdentitySave(data);
        this.loading = false;
        if (res.code === 200 && res.result) {
          this.MUT_USER_INFO_COMPANY(this.form.enterpriseName);
          this.$emit("submit-success", (res) => {
            if (res) {
              this.onCancel();
              this.$Message.success("添加成功！");
            }
          });
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    // 选择图片后处理
    handleBeforeUpload(file) {
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/png" &&
        file.type !== "image/jpg"
      ) {
        this.$Message.warning("图片要求上传jpg或者png格式或者jpeg格式");
        return false;
      }
      this.form.file = file;
      this.form.imgUrl = window.URL.createObjectURL(file);
      this.uploadCompanyPhoto();
      return false;
    },
    // 删除图片
    delImage() {
      this.form.imgUrl = "";
      this.form.file = "";
    },
    // 上传图片
    async uploadCompanyPhoto() {
      try {
        this.loading = true;
        const data = new FormData();
        data.append("file", this.form.file);
        const res = await enterpriseIdentityUpload(data);
        if (res.code === 200) {
          if (res.data.cpn != null && res.data.cpn !== "")
            this.form.enterpriseName = res.data.cpn;
          if (
            res.data.ca != null &&
            res.data.ca !== ""
          )
            this.form.certificateNumber = res.data.ca;
          if (res.data.person != null && res.data.person !== "")
            this.form.legalPerson = res.data.person;
          this.form.imgUrl = res.data.u;
          this.form.imgPathName = res.data.p;
        } else {
          this.deletePic();
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.section{
    padding: 30px 0;
  }
  .bj-rows{
    height: 45px;
    line-height: 45px;
    margin-bottom: 10px;
  }
  .name {
    color: #333333;
    font-size: 16px;
    min-width: 140px;
    text-align: right;
  }
  .c-bj-rows{
    display: flex;
    justify-content: center;
  }
  .upload-section{
    min-height: 122px;
    width: 248px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon2 {
      position: relative;
      width: 248px;
      height: 122px;
      background-size: cover;
      background-position: center;
      .close {
        position: absolute;
        right: 5px;
        top: 5px;
        cursor: pointer;
        color: #F85A36;
      }
  }
  .foot {
    border-top: 1px solid #dcdee2;
    padding-top: 16px;
    display: flex;
    justify-content: center;
  }
  ::v-deep .ivu-upload-drag:hover{
    border-color: #F85A36;
  }

</style>
